import { render, staticRenderFns } from "./centerRight2.vue?vue&type=template&id=3e22c18d&scoped=true&"
import script from "./centerRight2.vue?vue&type=script&lang=js&"
export * from "./centerRight2.vue?vue&type=script&lang=js&"
import style0 from "./centerRight2.vue?vue&type=style&index=0&id=3e22c18d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e22c18d",
  null
  
)

export default component.exports